import React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux';
import { activateUser, navigateTo } from '../../redux/actions';
import { Loading } from '../common';
import MyLink from '../common/MyLink';

class ActivatePaitent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: 'null',
      token: 'null',
      doneLoading: false,
      success: '',
      error: '',
    };
    this.finishLoading = this.finishLoading.bind(this);
  }
  getURLParams() {
    let params = new URLSearchParams(this.props.history.location.search);
    let paramsObject = {};
    for (let param of params) {
      paramsObject[param[0]] = param[1];
    }
    return paramsObject;
  }
  finishLoading(message, isSuccess = true) {
    this.setState({ doneLoading: true });
    isSuccess ? this.setState({ success: message }) : this.setState({ error: message });
  }
  componentDidMount() {
    console.log('ResetPassword componentDidMount');
    console.log(this.props.history.location);
    const { token, email } = this.getURLParams();
    this.props.activateUser(token, email, this.finishLoading);
  }

  render() {
    return (
      <div style={style.container}>
        <h1>Acocount Activation</h1>
        {!this.state.doneLoading && <Loading />}
        {this.state.doneLoading && (
          <>
            <div>
              <div style={style.error}>{this.state.error}</div>
              <div style={style.success}>{this.state.success}</div>
            </div>
            <MyLink pathname={'/'}>To Login</MyLink>
          </>
        )}
      </div>
    );
  }
}

const style = {
  container: {
    margin: '3rem',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  error: {
    fontWeight: 'bold',
    color: '#f7183a',
  },
  success: {
    fontWeight: 'bold',
    color: '#4CAF50',
  },
};

const mapStateToProps = (state, ownProps) => {
  return {};
};
const mapDispatchToProps = {
  navigateTo,
  activateUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(ActivatePaitent);
